export default __webpack_public_path__ + "static/media/LINE_spinner_dark.f38c18b7.svg";